module.exports = __webpack_public_path__ + "static/img/logo_tnp_white.97d31cb7.svg";